import React from 'react';
import { CheckCheckIcon } from 'lucide-react';
const WhatsAppMockup = () => {
  const messages = [{
    type: 'bot',
    text: "Hi. I'll help you submit your work order. Let's start with the basics.",
    time: '10:23 AM'
  }, {
    type: 'bot',
    text: 'What is the Work Order Number?',
    time: '10:23 AM'
  }, {
    type: 'user',
    text: 'WO-2024-1547',
    time: '10:24 AM'
  }, {
    type: 'bot',
    text: 'Got it! What date is this work order for?',
    time: '10:24 AM'
  }, {
    type: 'user',
    text: 'January 15, 2024',
    time: '10:24 AM'
  }, {
    type: 'bot',
    text: 'Perfect. Which Unit Number?',
    time: '10:24 AM'
  }, {
    type: 'user',
    text: 'Unit 304',
    time: '10:25 AM'
  }, {
    type: 'bot',
    text: 'Who are the workers on site today?',
    time: '10:25 AM'
  }, {
    type: 'user',
    text: 'John Smith and Maria Garcia',
    time: '10:25 AM'
  }, {
    type: 'bot',
    text: 'Great! What time did work start?',
    time: '10:25 AM'
  }, {
    type: 'user',
    text: '8:30 AM',
    time: '10:26 AM'
  }];
  return <div className="bg-[#0a1014] rounded-lg overflow-hidden shadow-2xl max-w-md mx-auto" data-id="element-450">
      {/* WhatsApp Header */}
      <div className="bg-[#1f2c34] px-4 py-3 flex items-center gap-3 border-b border-[#2a3942]" data-id="element-451">
        <div className="w-10 h-10 rounded-full bg-orange-500 flex items-center justify-center text-white font-semibold" data-id="element-452">
          AC
        </div>
        <div className="flex-1" data-id="element-453">
          <div className="text-white font-semibold" data-id="element-454">ACME Corp</div>
          <div className="text-[#8696a0] text-xs" data-id="element-455">online</div>
        </div>
      </div>
      {/* Chat Messages */}
      <div className="bg-[#0a1014] p-4 space-y-2" style={{
      backgroundImage: "url('data:image/svg+xml,%3Csvg width='60' height='60' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M0 0h60v60H0z' fill='%230a1014'/%3E%3Cpath d='M30 0L0 30l30 30 30-30z' fill='%23111b21' fill-opacity='0.1'/%3E%3C/svg%3E')",
      minHeight: '500px',
      maxHeight: '500px',
      overflowY: 'auto'
    }} data-id="element-456">
        {messages.map((message, index) => <div key={index} className={`flex ${message.type === 'user' ? 'justify-end' : 'justify-start'} mb-2`} data-id="element-457">
            <div className={`max-w-[75%] rounded-lg px-3 py-2 ${message.type === 'user' ? 'bg-[#005c4b] text-white' : 'bg-[#1f2c34] text-white'}`} data-id="element-458">
              <p className="text-sm leading-relaxed" data-id="element-459">{message.text}</p>
              <div className={`flex items-center justify-end gap-1 mt-1 ${message.type === 'user' ? 'text-[#8696a0]' : 'text-[#8696a0]'}`} data-id="element-460">
                <span className="text-[10px]" data-id="element-461">{message.time}</span>
                {message.type === 'user' && <CheckCheckIcon size={14} className="text-[#53bdeb]" data-id="element-462" />}
              </div>
            </div>
          </div>)}
      </div>
      {/* Input Area */}
      <div className="bg-[#1f2c34] px-4 py-2 border-t border-[#2a3942]" data-id="element-463">
        <div className="bg-[#2a3942] rounded-full px-4 py-2 text-[#8696a0] text-sm" data-id="element-464">
          Type a message
        </div>
      </div>
    </div>;
};
export default WhatsAppMockup;